import React from 'react'
import { change as changeFieldValue, formValueSelector, Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Select from 'react-select';
import axios from 'axios';
import $ from 'jquery';
import cadastrarUsuario from '../../../actions/usuario/cadastrarUsuario'
import { buscarUsuarios } from '../../../actions/usuario/buscarUsuarios';
import alterarUsuario from '../../../actions/usuario/alterarUsuario'
import selecionarPerfis from '../../../actions/perfil/selecionarPerfis';
import limparPerfis from '../../../actions/perfil/limparPerfis';
import {
    renderFieldCheck,
    renderFieldCnpj,
    renderFieldCpf,
    renderFieldEmail,
    renderFieldNumerosPorcentagem,
    renderFieldTelefone,
    required,
    tamanhoPorcentagem,
    validarCNPJ
} from '../../../util/inputs';
import { URL } from '../../../util/ambienteActions';
import { SLOW_REQUEST_CONFIG } from '../../../util/loadingUtil';
import buscarUsuarioPorEmail from '../../../actions/usuario/buscarUsuarioPorEmail';
import Autorizacao, { validaPerfis } from '../../../security/Autorizacao';
import { getAdminEmpresa, getGestorEmpresa, PERFIL_ADMIN } from '../../../security/securityContext';
import { showSuccessMsg, showAlertMsg } from '../../../util/messagesUtil';
import UsuarioLink from './UsuarioLink';
import adicionarPerfilUsuario from '../../../actions/usuario/adicionarPerfilUsuario';
import removerPerfilUsuario from '../../../actions/usuario/removerPerfilUsuario';
import { gerarHashForString } from '../../../util/stringUtil';

const TIPOS_PAGAMENTO_USUARIO = [
    { label: 'Cartão de Crédito', value: 'CARTAO_CREDITO' },
    { label: 'Cartão de Débito', value: 'CARTAO_DEBITO' },
    { label: 'PIX', value: 'PIX' },
    { label: 'Dinheiro', value: 'DINHEIRO' },
];

const OPCAO_DESCONTO_MEIA_PASSAGEM = [
    {
        label: 'Aplicar desconto no valor da Empresa',
        value: 'EMPRESA'
    },
    {
        label: 'Aplicar desconto no valor da ANTT',
        value: 'ANTT'
    },
    {
        label: 'Aplicar desconto no valor da ANTT e Empresa',
        value: 'ANTT_EMPRESA'
    }]

export const validate = (values) => {
    const errors = {};
    if (!values.nome) {
        errors.nome = 'Campo obrigatório'
    }
    if (!values.email) {
        errors.email = 'Campo obrigatório'
    }

    return errors
};

const renderField = ({
    input,
    label,
    type,
    css,
    max,
    readOnly,
    meta: { touched, error }
}) => (
    <div>
        <label className='mt-2'>{label}</label>
        <div>
            <input {...input} type={type}
                className={css}
                maxLength={max}
                style={{ borderColor: touched && error ? 'red' : '' }}
                disabled={readOnly}
                readOnly={readOnly} />
            {touched
                && (error && <span style={{ color: 'red' }}>{error}</span>)}
        </div>
    </div>
);

export class ModalAlterarUsuario extends React.Component {
    constructor(props) {
        super(props);
        this.fechar = this.fechar.bind(this);
        this.limparCampos = this.limparCampos.bind(this);
        this.limparFormulario = this.limparFormulario.bind(this);
        this.submit = this.submit.bind(this);
        this.handleAdicionarPagamentoDesativadoUsuario = this.handleAdicionarPagamentoDesativadoUsuario.bind(this);
        this.handleRemoverPagamentoDesativadoUsuario = this.handleRemoverPagamentoDesativadoUsuario.bind(this);
        this.adicionarDispositivoStone = this.adicionarDispositivoStone.bind(this);
        this.removerDispositivoStone = this.removerDispositivoStone.bind(this);
        this.state = {
            seNaoFoiAlteradoListaLinks: true,
            pagamentosDesativadosUsuario: [],
            dispositivosStoneSelecionados: [],
            novoDispositivoStone: { numeroSerie: '', apelido: '' }
        }

    }

    componentDidUpdate(prevProps) {
        if (prevProps.perfisSelecionados !== this.props.perfisSelecionados) {
            this.sincronizarComissoesComPerfis()
        }
        if (prevProps.usuarioSelecionado !== this.props.usuarioSelecionado && this.props.usuarioSelecionado) {
            const pagamentos = (this.props.usuarioSelecionado.pagamentosDesativados || [])
                .map(v => TIPOS_PAGAMENTO_USUARIO.find(t => t.value === v))
                .filter(Boolean);
            const dispositivosStone = (this.props.usuarioSelecionado.dispositivosStone || [])
                .map(d => ({ hash: gerarHashForString(d.numeroSerie), numeroSerie: d.numeroSerie, apelido: d.apelido }));
            this.setState({
                pagamentosDesativadosUsuario: pagamentos,
                dispositivosStoneSelecionados: dispositivosStone
            });
        }
    }

    // Não existe mais um catálogo pré-cadastrado pra escolher -- o admin digita
    // número de série + apelido aqui mesmo (mesmo padrão de UsuarioLink.js: monta
    // uma lista local e só grava tudo de uma vez quando o usuário é salvo).
    adicionarDispositivoStone() {
        const { novoDispositivoStone, dispositivosStoneSelecionados } = this.state;
        if (!novoDispositivoStone.numeroSerie) {
            showAlertMsg('Preencha o número de série da maquininha.');
            return;
        }
        const hash = gerarHashForString(novoDispositivoStone.numeroSerie);
        if (dispositivosStoneSelecionados.find(d => d.hash === hash)) {
            showAlertMsg('Essa maquininha já foi adicionada.');
            return;
        }
        this.setState({
            dispositivosStoneSelecionados: [...dispositivosStoneSelecionados, { hash, ...novoDispositivoStone }],
            novoDispositivoStone: { numeroSerie: '', apelido: '' }
        });
    }

    removerDispositivoStone(hash) {
        this.setState(prev => ({
            dispositivosStoneSelecionados: prev.dispositivosStoneSelecionados.filter(d => d.hash !== hash)
        }));
    }

    handleAdicionarPagamentoDesativadoUsuario(option) {
        this.setState(prev => {
            if (prev.pagamentosDesativadosUsuario.find(p => p.value === option.value)) return prev;
            return { pagamentosDesativadosUsuario: [...prev.pagamentosDesativadosUsuario, option] };
        });
    }

    handleRemoverPagamentoDesativadoUsuario(option) {
        this.setState(prev => ({
            pagamentosDesativadosUsuario: prev.pagamentosDesativadosUsuario.filter(p => p.value !== option.value),
        }));
    }

    sincronizarComissoesComPerfis() {
        const PERFIS_COMISSAO = ['ROLE_VENDEDOR_AGENCIA', 'ROLE_VENDEDOR_EMPRESA', 'ROLE_OPERADOR_REMARCACAO', 'ROLE_ADMIN_EMPRESA']
        const temVendedor = (this.props.perfisSelecionados || []).some(f => PERFIS_COMISSAO.includes(f.value))
        const reset = (campo) => this.props.changeFieldValue('formularioAlterarUsuario', campo, '00.00')

        if (!temVendedor) {
            reset('comissaoUsuario')
            reset('comissaoEncomenda')
            reset('comissaoExcessoBagagem')
            reset('comissaoImpressaoBilhete')
            reset('comissaoEntrega')
            reset('comissaoSeguro')
            reset('impostoRetido')
        } else if (this.props.empresaSelecionada && this.props.empresaSelecionada.grupo === 'TCB') {
            this.prencheCampoComissao('10.00')
            this.prencheCampoImpostoRetido('16.25')
        }
    }

    exibirComboPerfil(event) {
        const { perfis } = this.props
        return (
            <div>
                <Select
                    {...event.input}
                    noOptionsMessage={() => ('Nenhuma opção encontrada')}
                    placeholder='Adicionar um perfil...'
                    options={perfis}
                    isDisabled={this.naoPermiteEdicaoPerfilUsuarioSistema()}
                    onChange={(value) => {
                        event.input.onChange(value);
                        this.adicionarPerfil(value)
                    }}
                    onBlur={() => event.input.onBlur()}
                />
                {event.meta.touched
                    && (event.meta.error && <span style={{ color: 'red' }}>{event.meta.error}</span>)}
            </div>
        )
    }

    adicionarPerfil(perfil) {
        const url = `${URL}/perfil/${perfil.value}/usuario/${this.props.usuarioSelecionado.id}/empresa/${this.props.usuarioSelecionado.idEmpresa}/adicionar`;
        axios.post(url, SLOW_REQUEST_CONFIG)
            .then((resp) => {
                if (resp.status === 200) {
                    const perfis = Object.assign([], this.props.perfisSelecionados);
                    const perfiJaExiste = perfis.filter(f => f.value === perfil.value);
                    if (perfiJaExiste.length === 0) {
                        perfis.push(perfil);
                        this.props.selecionarPerfis(perfis)
                        this.props.adicionarPerfilUsuario(this.props.usuarioSelecionado, perfil);
                        this.props.buscarUsuario();
                    }
                }
            })
    }

    naoPermiteEdicaoPerfilUsuarioSistema() {
        return this.props.usuarioSelecionado?.usuarioSistema && !validaPerfis([PERFIL_ADMIN])
    }
    
    exibirAcrescimoMaximoPassagem() {
        return <div className="form-row mt-2">
            <div className="col-12 col-sm-6 col-md-6">
                <Field name='acrescimoMaximoPassagem' validate={[tamanhoPorcentagem]}
                    component={renderFieldNumerosPorcentagem}
                    css="form-control" label=" Acréscimo Máximo de Passagem(%)" />
            </div>
        </div>
    }

    exibirComissao() {
        const vendedor = this.props.perfisSelecionados
            .filter(f => f.value === 'ROLE_VENDEDOR_AGENCIA' || f.value === 'ROLE_VENDEDOR_EMPRESA' || f.value === 'ROLE_OPERADOR_REMARCACAO' || f.value === 'ROLE_ADMIN_EMPRESA');

        if (vendedor.length > 0) {
            if (this.props.empresaSelecionada.grupo === 'TCB') {
                return <div className="col-12 col-md-2" style={{paddingTop: '22px'}}>
                    <Field name='comissaoUsuario' validate={[required, tamanhoPorcentagem]}
                            component={renderFieldNumerosPorcentagem}
                            readOnly={true}
                            css="form-control" label="Comissão(%)" />
                </div>
            }
            return <div className="col-12 col-md-2" style={{paddingTop: '22px'}}>
                <Field name='comissaoUsuario' validate={[tamanhoPorcentagem]}
                        component={renderFieldNumerosPorcentagem}
                        css="form-control" label="Comissão(%)" />
            </div>
        }
        return ''
    }

    exibirComissaoEncomenda() {
        const vendedor = this.props.perfisSelecionados
            .filter(f => f.value === 'ROLE_VENDEDOR_AGENCIA' || f.value === 'ROLE_VENDEDOR_EMPRESA' || f.value === 'ROLE_OPERADOR_REMARCACAO' || f.value === 'ROLE_ADMIN_EMPRESA');

        if (vendedor.length > 0) {
            if (this.props.empresaSelecionada.grupo === 'TCB') {
                return <div className="col-12 col-md-2" style={{paddingTop: '22px'}}>
                    <Field name='comissaoEncomenda' validate={[required, tamanhoPorcentagem]}
                            component={renderFieldNumerosPorcentagem}
                            readOnly={true}
                            css="form-control" label="C.Encomenda(%)" />
                </div>
            }
            return <div className="col-12 col-md-2" style={{paddingTop: '22px'}}>
                <Field name='comissaoEncomenda' validate={[required, tamanhoPorcentagem]}
                        component={renderFieldNumerosPorcentagem}
                        css="form-control" label="C.Encomenda(%)" />
            </div>
        }
        return ''
    }

    exibirComissaoExcessoBagagem() {
        const vendedor = this.props.perfisSelecionados
            .filter(f => f.value === 'ROLE_VENDEDOR_AGENCIA' || f.value === 'ROLE_VENDEDOR_EMPRESA' || f.value === 'ROLE_OPERADOR_REMARCACAO' || f.value === 'ROLE_ADMIN_EMPRESA');

        if (vendedor.length > 0) {
            if (this.props.empresaSelecionada.grupo === 'TCB') {
                return <div className="col-12 col-md-2">
                    <Field name='comissaoExcessoBagagem' validate={[required, tamanhoPorcentagem]}
                            component={renderFieldNumerosPorcentagem}
                            readOnly={true}
                            css="form-control" label="C.Excesso Bagagem(%)" />
                </div>
            }
            return <div className="col-12 col-md-2">
                <Field name='comissaoExcessoBagagem' validate={[required, tamanhoPorcentagem]}
                        component={renderFieldNumerosPorcentagem}
                        css="form-control" label="C.Excesso Bagagem(%)" />
            </div>
        }
        return ''
    }

    exibirComissaoImpressaoBilhete() {
        const vendedor = this.props.perfisSelecionados
            .filter(f => f.value === 'ROLE_VENDEDOR_AGENCIA' || f.value === 'ROLE_VENDEDOR_EMPRESA' || f.value === 'ROLE_OPERADOR_REMARCACAO' || f.value === 'ROLE_ADMIN_EMPRESA');

        if (vendedor.length > 0) {
            if (this.props.empresaSelecionada.grupo === 'TCB') {
                return <div className="col-12 col-md-2">
                    <Field name='comissaoImpressaoBilhete' validate={[required, tamanhoPorcentagem]}
                            component={renderFieldNumerosPorcentagem}
                            readOnly={true}
                            css="form-control" label="C.Impressao Bilhete(%)" />
                </div>
            }
            return <div className="col-12 col-md-2">
                <Field name='comissaoImpressaoBilhete' validate={[required, tamanhoPorcentagem]}
                        component={renderFieldNumerosPorcentagem}
                        css="form-control" label="C.Impressao Bilhete(%)" />
            </div>
        }
        return ''
    }

    exibirComissaoEntrega() {
        const vendedor = this.props.perfisSelecionados
            .filter(f => f.value === 'ROLE_VENDEDOR_AGENCIA' || f.value === 'ROLE_VENDEDOR_EMPRESA' || f.value === 'ROLE_OPERADOR_REMARCACAO' || f.value === 'ROLE_ADMIN_EMPRESA');

        if (vendedor.length > 0) {
            if (this.props.empresaSelecionada.grupo === 'TCB') {
                return <div className="col-12 col-md-2">
                    <Field name='comissaoEntrega' validate={[required, tamanhoPorcentagem]}
                            component={renderFieldNumerosPorcentagem}
                            readOnly={true}
                            css="form-control" label="C.Entrega(%)" />
                </div>
            }
            return <div className="col-12 col-md-2">
                <Field name='comissaoEntrega' validate={[required, tamanhoPorcentagem]}
                        component={renderFieldNumerosPorcentagem}
                        css="form-control" label="C.Entrega(%)" />
            </div>
        }
        return ''
    }

    exibirComissaoSeguro() {
        const vendedor = this.props.perfisSelecionados
            .filter(f => f.value === 'ROLE_VENDEDOR_AGENCIA' || f.value === 'ROLE_VENDEDOR_EMPRESA' || f.value === 'ROLE_OPERADOR_REMARCACAO' || f.value === 'ROLE_ADMIN_EMPRESA');

        if (vendedor.length > 0) {
            if (this.props.empresaSelecionada.grupo === 'TCB') {
                return <div className="col-12 col-md-2">
                    <Field name='comissaoSeguro' validate={[required, tamanhoPorcentagem]}
                            component={renderFieldNumerosPorcentagem}
                            readOnly={true}
                            css="form-control" label="C.Seguro(%)" />
                </div>
            }
            return <div className="col-12 col-md-2">
                <Field name='comissaoSeguro' validate={[required, tamanhoPorcentagem]}
                        component={renderFieldNumerosPorcentagem}
                        css="form-control" label="C.Seguro(%)" />
            </div>
        }
        return ''
    }

    prencheCampoComissao(valor) {
        this.props.changeFieldValue('formularioAlterarUsuario', 'comissaoUsuario',
            this.props.comissaoUsuario ? this.props.comissaoUsuario : valor);
        this.props.changeFieldValue('formularioAlterarUsuario', 'comissaoEncomenda',
                this.props.comissaoEncomenda ? this.props.comissaoEncomenda : valor);
    }

    prencheCampoImpostoRetido(valor) {
        this.props.changeFieldValue('formularioAlterarUsuario', 'impostoRetido',
            this.props.usuarioSelecionado.impostoRetido ? this.props.usuarioSelecionado.impostoRetido : valor);
    }

    exibirImpostoRetido() {
        const vendedor = this.props.perfisSelecionados
            .filter(f => f.value === 'ROLE_VENDEDOR_AGENCIA' || f.value === 'ROLE_VENDEDOR_EMPRESA' || f.value === 'ROLE_OPERADOR_REMARCACAO' || f.value === 'ROLE_ADMIN_EMPRESA');

        if (vendedor.length > 0) {
            if (this.props.empresaSelecionada.grupo === 'TCB' || this.props.empresaSelecionada.grupo === 'BUSER' || this.props.empresaSelecionada.grupo === 'CIDAO') {
                if (this.props.empresaSelecionada.id == 808) {
                    return <div className="form-group">
                        <label>Imposto retido(%)</label>
                        <input type="text" className="form-control col-md-2" readOnly={true} value='0.00' name='impostoRetido' />
                    </div>
                }
                return <div className="form-row">
                    <div className="col-12 col-sm-6 col-md-6">
                        <Field name='impostoRetido' validate={[required, tamanhoPorcentagem]}
                            component={renderFieldNumerosPorcentagem}
                            readOnly={true}
                            css="form-control" label="imposto retido(%)" />
                    </div>
                </div>
            }
            return <div className="form-row">
                <div className="col-12 col-sm-6 col-md-6">
                    <Field name='impostoRetido' validate={[required, tamanhoPorcentagem]}
                        component={renderFieldNumerosPorcentagem}
                        css="form-control" label="imposto retido(%)" />
                </div>
            </div>
        }
        return ''
    }

    montarParametroUsuario(values) {
        const comissoes = [{ tipoServico: 'RESERVA', porcentagem: values.comissaoUsuario }, { tipoServico: 'ENCOMENDA', porcentagem: values.comissaoEncomenda },
            { tipoServico: 'EXCESSO_BAGAGEM', porcentagem: values.comissaoExcessoBagagem },  { tipoServico: 'IMPRESSAO_BILHETE', porcentagem: values.comissaoImpressaoBilhete },
            { tipoServico: 'ENTREGA_ENCOMENDA', porcentagem: values.comissaoEntrega },
            { tipoServico: 'SEGURO', porcentagem: values.comissaoSeguro }
        ].filter(c => c.porcentagem !== undefined && c.porcentagem !== null && c.porcentagem !== ''); // remove comissões não preenchidas (perfil sem exigência de comissão)


        return {
            id: this.props.usuarioSelecionado.id,
            nome: values.nome,
            email: values.email,
            comissoes: comissoes,            
            impostoRetido: values.impostoRetido,
            telefone: values.telefoneUsuario,
            cpf: values.cpf,
            tipoDescontoMeiaPassagem: values.opcaoDescontoMeiaPassagem ? values.opcaoDescontoMeiaPassagem.value : 'EMPRESA',
            venderCte: values.venderCte,
            venderValorANTT: values.venderValorANTT,
            vendeGratuidade: values.vendeGratuidade,
            vendaTEF: values.vendaTEF,
            cnpjTef: values.numeroCnpjTef,
            storeIdTef: values.storeIdTef,
            habilitadoLinkPagamento: values.habilitadoLinkPagamento,            
            habilitadoCieloEcommerce: values.habilitadoCieloEcommerce,
            habilitadoSicoob: values.habilitadoSicoob,
            habilitadoStoneConnect: values.habilitadoStoneConnect,
            links: this.props.linksSelecionados,
            acrescimoMaximoPassagem: values.acrescimoMaximoPassagem || '00.00',
            habilitadoBloqueioEdicaoPassageiro: values.habilitadoBloqueioEdicaoPassageiro,
            habilitadoBloqueioReimpressaoCupom: values.habilitadoBloqueioReimpressaoCupom,
            habilitadoComissionamentoReimpresaoPassagem: values.habilitadoComissionamentoReimpresaoPassagem,
            habilitadoAutenticacaoDoisFatores: values.habilitadoAutenticacaoDoisFatores,
            habilitadoBloqueioListaPassageiro: values.habilitadoBloqueioListaPassageiro,
            habilitadoBloqueioBuscarReservasTerceiros: values.habilitadoBloqueioBuscarReservasTerceiros,
            habilitadoAcessoEncomenda: values.habilitadoAcessoEncomenda,
            habilitadoVendaOffline: values.habilitadoVendaOffline || false,
            habilitadoVendaUrbana: values.habilitadoVendaUrbana || false,
            habilitadoEncomendaAvulsa: values.habilitadoEncomendaAvulsa || false,
            habilitadoComissaoEntregaEncomenda: values.habilitadoComissaoEntregaEncomenda || false,
            habilitadoAcessoPassagens: values.habilitadoAcessoPassagens,
            usuarioSistema: values.usuarioSistema,
            pagamentosDesativados: this.state.pagamentosDesativadosUsuario.map(p => p.value),
            dispositivosStone: this.state.dispositivosStoneSelecionados.map(d => ({ numeroSerie: d.numeroSerie, apelido: d.apelido }))
        };
    }

    submit(values) {
        this.props.alterarUsuario(this.montarParametroUsuario(values), this.props.usuarioSelecionado.idEmpresa)
            .then(() => {
                showSuccessMsg('Usuario alterado com sucesso');
                this.limparFormulario();
                this.props.buscarUsuario();
                this.fecharModal();
            })
    }

    fecharModal() {
        $('#modalAlterarUsuario')
            .modal('hide');
        $('#modalAlterarUsuario')
            .hide();
        $('.modalAlterarUsuario')
            .hide();
    }

    limparFormulario() {
        this.props.reset('formularioAlterarUsuario');
        this.setState({ perfisSelecionados: [] });
        this.props.limparPerfis();
        this.props.limparLinks();
        this.verificaSeNaoFoiAlteradoLinks(true);
    }

    limparCampos() {
        this.props.changeFieldValue('formularioAlterarUsuario',
            'nome', '');
        this.props.changeFieldValue('formularioAlterarUsuario',
            'nomeUsuario', '');
        this.props.changeFieldValue('formularioAlterarUsuario',
            'email', '');
        this.props.changeFieldValue('formularioAlterarUsuario',
            'comissao', '');
        this.props.changeFieldValue('formularioAlterarUsuario',
            'impostoRetido', '');
        this.props.changeFieldValue('formularioAlterarUsuario',
            'agencia', '');
        this.setState({ usuario: null });
        this.props.limparPerfis();
    }

    removerPerfil(perfil) {
        const url = `${URL}/perfil/${perfil.value}/usuario/${this.props.usuarioSelecionado.id}/empresa/${this.props.usuarioSelecionado.idEmpresa}/remover`;
        axios.get(url, SLOW_REQUEST_CONFIG)
            .then((resp) => {
                if (resp.status === 200) {
                    const perfis = Object.assign([], this.props.perfisSelecionados);
                    const novaLista = perfis.filter(f => f.value !== perfil.value);
                    this.props.selecionarPerfis(novaLista)
                    this.props.removerPerfilUsuario(this.props.usuarioSelecionado, perfil);
                    this.props.buscarUsuario();
                }
            })
    }

    removerAgencia() {
        this.props.changeFieldValue('formularioAlterarUsuario',
            'agencia', '');
    }

    exibirComboOpcaoDescontoMeiaPassagem(event) {
        return (
            <div>
                <Select
                    {...event.input}
                    noOptionsMessage={() => ('Nenhuma opção encontrada')}
                    placeholder='Adicionar uma opção de desconto'
                    options={OPCAO_DESCONTO_MEIA_PASSAGEM}
                    onChange={(value) => {
                        event.input.onChange(value);
                    }}
                    onBlur={() => event.input.onBlur()}
                />
                {event.meta.touched
                    && (event.meta.error && <span style={{ color: 'red' }}>{event.meta.error}</span>)}
            </div>
        )
    }

    exibirPerfisSelecionados() {
        const ehAdmin = validaPerfis([PERFIL_ADMIN])

        if (this.props.perfisSelecionados) {
            return this.props.perfisSelecionados.map(perfil => {
                if ((perfil.value === 'ROLE_FINANCEIRO_EMPRESA' || perfil.value === 'ROLE_GESTOR_EMPRESA') && !ehAdmin) {
                    return null;
                }
                return (
                    <div key={perfil.value} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px', padding: '4px 10px', background: '#f5f5f5', borderRadius: '4px' }}>
                        <span style={{ flex: 1, fontSize: '13px' }}>{perfil.label}</span>
                        {!this.naoPermiteEdicaoPerfilUsuarioSistema() ? (
                            <i className="material-icons" style={{ cursor: 'pointer', fontSize: '18px', color: '#e53935' }}
                                onClick={() => this.removerPerfil(perfil)}>delete</i>
                        ) : null}
                    </div>
                );
            })
        }
        return ''
    }

    exibirOpcaoDescontoMeiaPassagemo() {
        const vendedor = this.props.perfisSelecionados
            .filter(f => f.value === 'ROLE_VENDEDOR_AGENCIA' || f.value === 'ROLE_VENDEDOR_EMPRESA' || f.value === 'ROLE_OPERADOR_REMARCACAO' || f.value === 'ROLE_ADMIN_EMPRESA');
        if (vendedor.length > 0) {
            return (
                <div className="form-row mt-2">
                    <div className="col-12 col-sm-9 col-md-6">
                        <label>Opções de desconto de meia passagem </label>
                        <Field name='opcaoDescontoMeiaPassagem' required={true}
                            component={this.exibirComboOpcaoDescontoMeiaPassagem.bind(this)} />
                    </div>
                </div>
            )
        }
        return ''
    }

    verificaSeNaoFoiAlteradoLinks(valor) {
        this.setState({ seNaoFoiAlteradoListaLinks: valor });
    }

    fechar() {
        this.props.limparPerfis();
        this.limparFormulario();
    }

    render() {
        const {
            handleSubmit, submitting, invalid, pristine
        } = this.props;
        const usuarioSelecionado = this.props.usuarioSelecionado;
        const empresaSelecionada = this.props.empresaSelecionada;
        const naoPermiteAlterarDados = usuarioSelecionado && empresaSelecionada &&
            usuarioSelecionado.idEmpresaCadastradora !== empresaSelecionada.id && !validaPerfis([PERFIL_ADMIN]);
        const permiteMudarFlagValorANTT = !validaPerfis([PERFIL_ADMIN])

        return (
            <div className="modal fade show" id='modalAlterarUsuario' role='dialog'
                aria-labelledby='modalAlterarUsuario' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-lg'}>
                    <div className="modal-content vx-modal-content">
                        <div className="vx-modal-header">
                            <div className="vx-modal-header-icon">
                                <i className="material-icons">edit</i>
                            </div>
                            <div>
                                <h5 className="vx-modal-title">Editar Usuário</h5>
                            </div>
                            <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Close"
                                onClick={() => this.fechar()}>
                                <i className="material-icons">close</i>
                            </button>
                        </div>
                        <div className="vx-modal-body">
                            {naoPermiteAlterarDados ? <div className="mt-2 alert alert-warning" role="alert">
                                Usuário cadastrado por outra empresa.
                            </div> : ''}
                            <form onSubmit={handleSubmit(this.submit)}>
                                <div className="form-row">
                                    <div className="col-12 col-sm-6 col-md-6">
                                        <Field name="email" type="email" component={renderFieldEmail} label="E-mail:"
                                            css="form-control" readOnly={naoPermiteAlterarDados} />
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-6">
                                        <Field name="cpf" type="text" component={renderFieldCpf} label="CPF:"
                                            css="form-control" readOnly={naoPermiteAlterarDados} />
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="col-12 col-sm-8 col-md-8">
                                        <Field name="nome" type="text" required={true} component={renderField}
                                            label="Nome Completo:"
                                            readOnly={naoPermiteAlterarDados}
                                            css="form-control" />
                                    </div>
                                    <div className="col-12 col-sm-4 col-md-4">
                                        <Field name="telefoneUsuario" type="text" required={true}
                                            component={renderFieldTelefone}
                                            readOnly={naoPermiteAlterarDados}
                                            css="form-control" label="Telefone" />
                                    </div>
                                </div>

                                <div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-6">
                                            <label>Perfil usuário</label>
                                            <Field name='perfil'
                                                required={true}
                                                component={this.exibirComboPerfil.bind(this)}
                                                css="form-control col-md-12"
                                            />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-6">
                                            <div>
                                                {this.exibirPerfisSelecionados()}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='venderCte' type="checkbox" component={renderFieldCheck}
                                                readOnly={false}
                                                label="Vender com cte"
                                                css="form-check-input" />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='venderValorANTT' type="checkbox" component={renderFieldCheck}
                                                readOnly={permiteMudarFlagValorANTT}
                                                label="Vender com valor antt"
                                                css="form-check-input" />
                                        </div>
                                    </div>
                                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                                        <div className="form-row mt-2">
                                            <div className="col-12 col-sm-9 col-md-9">
                                                <Field name='usuarioSistema' type="checkbox" component={renderFieldCheck}
                                                    label="Usuário de Sistema (integração)"
                                                    css="form-check-input" readOnly={false} />
                                            </div>
                                        </div>
                                    </Autorizacao>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='vendeGratuidade' type="checkbox" component={renderFieldCheck}
                                                label="Vender Gratuidade"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>                                    
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoBloqueioEdicaoPassageiro' type="checkbox" component={renderFieldCheck}
                                                label="Bloquear Edição de Passagens"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoBloqueioReimpressaoCupom' type="checkbox" component={renderFieldCheck}
                                                label="Bloquear Impressão de Passagens"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoBloqueioListaPassageiro' type="checkbox" component={renderFieldCheck}
                                                    label="Bloquear lista de passageiro"
                                                    css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoBloqueioBuscarReservasTerceiros' type="checkbox" component={renderFieldCheck}
                                                label="Bloquear Cancelar/Remarcar/Em Aberto Reservas de Terceiros"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoAcessoEncomenda' type="checkbox" component={renderFieldCheck}
                                                label="Habilitar Acesso Encomenda"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoAcessoPassagens' type="checkbox" component={renderFieldCheck}
                                                label="Habilitar Acesso Módulo de Passagens"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoVendaOffline' type="checkbox" component={renderFieldCheck}
                                                label="Habilitar Venda Offline"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoVendaUrbana' type="checkbox" component={renderFieldCheck}
                                                label="Habilitar Vendas Urbanas"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoEncomendaAvulsa' type="checkbox" component={renderFieldCheck}
                                                label="Habilitar Encomenda Avulsa"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoComissaoEntregaEncomenda' type="checkbox" component={renderFieldCheck}
                                                label="Habilitar Comissão de Entrega de Encomenda"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>

                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <label className='mt-2'>Pagamentos Desativados (Usuário)</label>
                                            <Select
                                                placeholder='Selecione o Tipo de Pagamento'
                                                styles={{
                                                    control: base => ({
                                                        ...base,
                                                        height: 35,
                                                        minHeight: 32,
                                                        fontSize: 16,
                                                        width: '100%',
                                                        borderColor: '#e4e7ea',
                                                        cursor: 'pointer'
                                                    })
                                                }}
                                                noOptionsMessage={() => 'Nenhuma opção disponível'}
                                                options={TIPOS_PAGAMENTO_USUARIO
                                                    .filter(tp => !(this.props.pagamentosDesativados || []).includes(tp.value))
                                                    .filter(tp => !this.state.pagamentosDesativadosUsuario.find(p => p.value === tp.value))
                                                }
                                                value={null}
                                                onChange={e => this.handleAdicionarPagamentoDesativadoUsuario(e)}
                                            />
                                            <div className="mt-1">
                                                {this.state.pagamentosDesativadosUsuario.map(p => (
                                                    <span key={`pdu_${p.value}`} className="badge badge-secondary mr-1" style={{ cursor: 'pointer' }}
                                                        onClick={() => this.handleRemoverPagamentoDesativadoUsuario(p)}>
                                                        {p.label} &times;
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    </div>                                    
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoAutenticacaoDoisFatores' type="checkbox" component={renderFieldCheck}
                                                label="Habilitar Autenticação Com 2 Fatores"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='vendaTEF' type="checkbox" component={renderFieldCheck}
                                                label="Vender TEF"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    {!(this.props.pagamentosDesativados || []).includes('LINK_PAGAMENTO') && (
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoLinkPagamento' type="checkbox" component={renderFieldCheck}
                                                label="Vender Link Pagamento"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    )}
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoCieloEcommerce' type="checkbox" component={renderFieldCheck}
                                                label="Venda via PIX (Cielo E-commerce)"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoSicoob' type="checkbox" component={renderFieldCheck}
                                                label="Venda via PIX (Sicoob)"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN,getAdminEmpresa(this.props.empresaSelecionada.id)
                                        ,getGestorEmpresa(this.props.empresaSelecionada.id)]}>
                                        <div className="form-row mt-2">
                                            <div className="col-12 col-sm-9 col-md-9">
                                                <Field name='habilitadoStoneConnect' type="checkbox" component={renderFieldCheck}
                                                    label="Venda via Connect Stone"
                                                    css="form-check-input" readOnly={false} />
                                            </div>
                                        </div>
                                        
                                        <div className="form-row mt-2">
                                            <div className="col-12 col-sm-9 col-md-9">
                                                <label className='mt-2'>Maquininhas Stone deste usuário</label>
                                                <div className="form-row">
                                                    <div className="form-group col-5">
                                                        <label>Número de série (devices_serial_number)</label>
                                                        <input className="form-control" type="text" placeholder="Número de série"
                                                            value={this.state.novoDispositivoStone.numeroSerie}
                                                            onChange={e => this.setState({ novoDispositivoStone: { ...this.state.novoDispositivoStone, numeroSerie: e.target.value } })} />
                                                    </div>
                                                    <div className="form-group col-5">
                                                        <label>Apelido (uso interno, não enviado à Stone)</label>
                                                        <input className="form-control" type="text" placeholder="Ex.: Balcão 1"
                                                            value={this.state.novoDispositivoStone.apelido}
                                                            onChange={e => this.setState({ novoDispositivoStone: { ...this.state.novoDispositivoStone, apelido: e.target.value } })} />
                                                    </div>
                                                    <div className="form-group col-2 d-flex align-items-end">
                                                        <button type="button" className="btn btn-laranja btn-sm mb-3" onClick={this.adicionarDispositivoStone}>
                                                            + Adicionar
                                                        </button>
                                                    </div>
                                                </div>
                                                <table className="table table-sm table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">Número de série</th>
                                                            <th scope="col">Apelido</th>
                                                            <th scope="col"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.dispositivosStoneSelecionados.length === 0 ? (
                                                            <tr className="alert alert-warning text-center" role="alert">
                                                                <td colSpan="3">Nenhuma maquininha adicionada.</td>
                                                            </tr>
                                                        ) : this.state.dispositivosStoneSelecionados.map(d => (
                                                            <tr key={d.hash}>
                                                                <td>{d.numeroSerie}</td>
                                                                <td>{d.apelido}</td>
                                                                <td className="text-center" style={{ cursor: 'pointer', color: 'red' }}>
                                                                    <div onClick={() => this.removerDispositivoStone(d.hash)}>
                                                                        Remover
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>                                        
                                    </Autorizacao>
                                    {this.props.vendaTEF ? <><div className="form-row mb-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name="numeroCnpjTef" css='form-control' validate={[required, validarCNPJ]}
                                                component={renderFieldCnpj} label="Número CNPJ"/>
                                        </div>
                                    </div>
                                    <div className="form-row mb-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name="storeIdTef" type="text"
                                                component={renderField}                                
                                                label="Store ID TEF"
                                                css="form-control col-md-4"
                                                validate={[required]}
                                            />
                                        </div>
                                    </div></>: ''}
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoComissionamentoReimpresaoPassagem' type="checkbox" component={renderFieldCheck}
                                                label="Habilitar Comissão Passagens Reimpressas de Terceiros"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    {this.exibirAcrescimoMaximoPassagem()}
                                    <div className="form-row">
                                        {this.exibirComissao()}
                                        {this.exibirComissaoEncomenda()}
                                        {this.exibirComissaoExcessoBagagem()}
                                        {this.exibirComissaoImpressaoBilhete()}
                                        {this.exibirComissaoEntrega()}
                                        {this.exibirComissaoSeguro()}
                                    </div>
                                    {this.exibirImpostoRetido()}
                                    {this.exibirOpcaoDescontoMeiaPassagemo()}
                                </div>
                                <div className="form-row">
                                    <UsuarioLink
                                        linksSelecionados={this.props.linksSelecionados}
                                        alterarValoresLinksSelecionados={this.props.alterarValoresLinksSelecionados}
                                        verificaSeNaoFoiAlteradoLinks={this.verificaSeNaoFoiAlteradoLinks.bind(this)}
                                        classCss={'campoUrlModalAlterarUsuario'}
                                        ehUsuarioAgencia={false}
                                    />
                                </div>

                                <div className="form-group area-codigo">
                                    <Field name="idUsuario" type="hidden" component={renderField}
                                        css="form-control col-md-12" />
                                </div>
                                <div className="vx-modal-footer">
                                    <button type="submit" disabled={(invalid || submitting || pristine) && this.state.seNaoFoiAlteradoListaLinks
                                        && this.naoPermiteEdicaoPerfilUsuarioSistema()}
                                        className="vx-btn-primary">Salvar
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        perfisSelecionados: state.perfisSelecionados,
        empresaSelecionada: state.empresaSelecionada,
        paginaAtual: state.paginaAtualUsuario,
        registrosPorPagina: state.registrosPorPaginaUsuario,
        usuarioSelecionado: state.usuarioSelecionado,
        comissaoUsuario: formValueSelector('formularioAlterarUsuario')(state, 'comissaoUsuario'),
        vendaTEF: formValueSelector('formularioAlterarUsuario')(state, 'vendaTEF'),
        habilitadoStoneConnectUsuario: formValueSelector('formularioAlterarUsuario')(state, 'habilitadoStoneConnect'),
        numeroCnpjTef: formValueSelector('formularioAlterarUsuario')(state, 'numeroCnpjTef'),
        storeIdTef: formValueSelector('formularioAlterarUsuario')(state, 'storeIdTef'),
        pagamentosDesativados: state.pagamentosDesativados ? state.pagamentosDesativados.pagamentosDesativados : [],
        initialValues: {
            email: state.usuarioSelecionado ? state.usuarioSelecionado.email : '',
            nome: state.usuarioSelecionado ? state.usuarioSelecionado.nome : '',
            cpf: state.usuarioSelecionado ? state.usuarioSelecionado.cpfCnpj : '',
            telefoneUsuario: state.usuarioSelecionado ? state.usuarioSelecionado.telefone : '',
            agencia: state.usuarioSelecionado && state.usuarioSelecionado.codigoAgencia ? {
                label: state.usuarioSelecionado.nomeAgencia,
                value: state.usuarioSelecionado.codigoAgencia
            } : null,
            opcaoDescontoMeiaPassagem: {
                label: state.usuarioSelecionado ? state.usuarioSelecionado.descTipoDescontoMeiaPassagem : '',
                value: state.usuarioSelecionado ? state.usuarioSelecionado.valorTipoDescontoMeiaPassagem : ''
            },             
            comissaoUsuario: state.usuarioSelecionado
                && state.usuarioSelecionado.comissoes
                && state.usuarioSelecionado.comissoes.length 
                && state.usuarioSelecionado.comissoes.find(it => it.tipoServico == 'RESERVA')
                ? state.usuarioSelecionado.comissoes.find(it => it.tipoServico == 'RESERVA').porcentagem : '00.00',
            comissaoEncomenda:  state.usuarioSelecionado
                && state.usuarioSelecionado.comissoes
                && state.usuarioSelecionado.comissoes.length 
                && state.usuarioSelecionado.comissoes.find(it => it.tipoServico == 'ENCOMENDA')
                ? state.usuarioSelecionado.comissoes.find(it => it.tipoServico == 'ENCOMENDA').porcentagem : '00.00',            
            comissaoExcessoBagagem: state.usuarioSelecionado
                && state.usuarioSelecionado.comissoes
                && state.usuarioSelecionado.comissoes.length 
                && state.usuarioSelecionado.comissoes.find(it => it.tipoServico == 'EXCESSO_BAGAGEM')
                ? state.usuarioSelecionado.comissoes.find(it => it.tipoServico == 'EXCESSO_BAGAGEM').porcentagem : '00.00',
            comissaoImpressaoBilhete: state.usuarioSelecionado
                && state.usuarioSelecionado.comissoes
                && state.usuarioSelecionado.comissoes.length
                && state.usuarioSelecionado.comissoes.find(it => it.tipoServico == 'IMPRESSAO_BILHETE')
                ? state.usuarioSelecionado.comissoes.find(it => it.tipoServico == 'IMPRESSAO_BILHETE').porcentagem : '00.00',
            comissaoEntrega: state.usuarioSelecionado
                && state.usuarioSelecionado.comissoes
                && state.usuarioSelecionado.comissoes.length
                && state.usuarioSelecionado.comissoes.find(it => it.tipoServico == 'ENTREGA_ENCOMENDA')
                ? state.usuarioSelecionado.comissoes.find(it => it.tipoServico == 'ENTREGA_ENCOMENDA').porcentagem : '00.00',
            comissaoSeguro: state.usuarioSelecionado
                && state.usuarioSelecionado.comissoes
                && state.usuarioSelecionado.comissoes.length
                && state.usuarioSelecionado.comissoes.find(it => it.tipoServico == 'SEGURO')
                ? state.usuarioSelecionado.comissoes.find(it => it.tipoServico == 'SEGURO').porcentagem : '00.00',
            impostoRetido: state.usuarioSelecionado ? (state.usuarioSelecionado.impostoRetido ? state.usuarioSelecionado.impostoRetido : '00.00') : '00.00',
            venderCte: state.usuarioSelecionado ? state.usuarioSelecionado.venderCte : '',
            venderValorANTT: state.usuarioSelecionado ? state.usuarioSelecionado.venderValorANTT : '',
            vendeGratuidade: state.usuarioSelecionado ? state.usuarioSelecionado.vendeGratuidade : '',            
            habilitadoComissionamentoReimpresaoPassagem: state.usuarioSelecionado ? state.usuarioSelecionado.habilitadoComissionamentoReimpresaoPassagem : '',            
            vendaTEF: state.usuarioSelecionado ? state.usuarioSelecionado.vendaTEF : '',
            numeroCnpjTef: state.usuarioSelecionado ? state.usuarioSelecionado.cnpjTef : '',
            storeIdTef: state.usuarioSelecionado ? state.usuarioSelecionado.storeIdTef : '',
            habilitadoLinkPagamento: state.usuarioSelecionado ? state.usuarioSelecionado.habilitadoLinkPagamento : '',
            habilitadoCieloSmart: state.usuarioSelecionado ? state.usuarioSelecionado.habilitadoCieloSmart : false,
            merchantIdCieloSmart: state.usuarioSelecionado ? state.usuarioSelecionado.merchantIdCieloSmart : '',
            habilitadoCieloEcommerce: state.usuarioSelecionado ? state.usuarioSelecionado.habilitadoCieloEcommerce : false,
            habilitadoSicoob: state.usuarioSelecionado ? state.usuarioSelecionado.habilitadoSicoob : false,
            habilitadoStoneConnect: state.usuarioSelecionado ? state.usuarioSelecionado.habilitadoStoneConnect : false,
            usuarioSistema: state.usuarioSelecionado ? state.usuarioSelecionado.usuarioSistema : '',
            acrescimoMaximoPassagem: state.usuarioSelecionado ? state.usuarioSelecionado.acrescimoMaximoPassagem : '0',            
            habilitadoBloqueioEdicaoPassageiro: state.usuarioSelecionado ? state.usuarioSelecionado.habilitadoBloqueioEdicaoPassageiro : '',
            habilitadoBloqueioReimpressaoCupom: state.usuarioSelecionado ? state.usuarioSelecionado.habilitadoBloqueioReimpressaoCupom : '',
            habilitadoAutenticacaoDoisFatores: state.usuarioSelecionado ? state.usuarioSelecionado.habilitadoAutenticacaoDoisFatores : '',
            habilitadoBloqueioListaPassageiro: state.usuarioSelecionado ? state.usuarioSelecionado.habilitadoBloqueioListaPassageiro : '',
            habilitadoBloqueioBuscarReservasTerceiros: state.usuarioSelecionado ? state.usuarioSelecionado.habilitadoBloqueioBuscarReservasTerceiros : '',
            habilitadoAcessoEncomenda: state.usuarioSelecionado ? state.usuarioSelecionado.habilitadoAcessoEncomenda : '',
            habilitadoAcessoPassagens: state.usuarioSelecionado ? state.usuarioSelecionado.habilitadoAcessoPassagens : '',
            habilitadoVendaOffline: state.usuarioSelecionado ? state.usuarioSelecionado.habilitadoVendaOffline : false,
            habilitadoVendaUrbana: state.usuarioSelecionado ? state.usuarioSelecionado.habilitadoVendaUrbana : false,
            habilitadoEncomendaAvulsa: state.usuarioSelecionado ? state.usuarioSelecionado.habilitadoEncomendaAvulsa : false,
            habilitadoComissaoEntregaEncomenda: state.usuarioSelecionado ? state.usuarioSelecionado.habilitadoComissaoEntregaEncomenda : false,
        }
    }
}


export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        cadastrarUsuario,
        buscarUsuarios,
        selecionarPerfis,
        buscarUsuarioPorEmail,
        alterarUsuario,
        limparPerfis,
        adicionarPerfilUsuario,
        removerPerfilUsuario
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioAlterarUsuario',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
})(ModalAlterarUsuario));
